/* HEIMWEH - Fortschrittsleiste der Bildergalerie, NUR MOBIL.
   Gehoert zu assets/hw-pdp-slider.css, dort steht die Begruendung und
   die Rechnung. Geladen wird das CSS im Head (layout/theme.liquid),
   dieses Skript in snippets/hw-hersteller-label.liquid.
*/
(function () {
  'use strict';

  /* Bildanzahl ueber die VERSCHIEDENEN data-media-id, nicht ueber die
     Slides: die Endlosschleife von Swiper legt Kopien an. */
  function mediaCount(gallery) {
    var items = gallery.querySelectorAll('.product__media-list .product__media-item');
    var seen = {};
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      var id = items[i].getAttribute('data-media-id');
      if (!id || seen[id]) continue;
      seen[id] = true;
      n++;
    }
    return n;
  }

  /* ALTE INDIKATOREN STILLLEGEN.
     Das Ausblenden selbst macht das CSS, damit beim Laden nichts
     aufblitzt. Hier werden nur Elemente nachgetragen, die Swiper erst
     spaeter anlegt. */
  var NAME_PATTERN = /(pagination|bullet|dots|thumb|indicator|counter|slider-controls)/i;

  function classOf(el) {
    var c = el.className;
    return typeof c === 'string' ? c : '';
  }

  function markIndicators(gallery, viewer, bar) {
    /* HARTE SPERRE: nie etwas ausblenden, das die Bildspur enthaelt.
       Am 31.10.2026 war genau das passiert, der Galerierahmen traegt
       selbst die Klasse slider-controls--below und die komplette
       Galerie war weg. */
    function mark(el) {
      if (!el || !el.classList) return;
      if (el === viewer || el === bar) return;
      if (el.contains && (el.contains(viewer) || el.contains(bar))) return;
      el.classList.add('hw-ind-off');
    }

    var wrap = gallery.querySelector('.product__media-gallery-viewer-wrap');
    if (wrap) {
      var wc = wrap.children;
      for (var a = 0; a < wc.length; a++) mark(wc[a]);
    }

    var vc = viewer.children;
    for (var b = 0; b < vc.length; b++) {
      var cls = classOf(vc[b]);
      if (cls.indexOf('swiper-wrapper') !== -1) continue;
      if (cls.indexOf('skip-to-content-link') !== -1) continue;
      mark(vc[b]);
    }

    var scope = gallery.closest('.product__media-wrapper') || gallery;
    var all = scope.querySelectorAll('*');
    for (var d = 0; d < all.length; d++) {
      var el = all[d];
      if (!NAME_PATTERN.test(classOf(el))) continue;
      if (el.closest('.product__media-list')) continue;
      if (el.closest('.hw-gal-bar')) continue;
      mark(el);
    }
  }

  function update(gallery, bar, swiper) {
    var n = mediaCount(gallery);
    if (n < 2) {
      bar.classList.add('hw-gal-bar--off');
      return;
    }
    bar.classList.remove('hw-gal-bar--off');
    var i = swiper && typeof swiper.realIndex === 'number' ? swiper.realIndex : 0;
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;
    bar.style.setProperty('--hw-n', n);
    bar.style.setProperty('--hw-i', i);
  }

  function ensureBar(gallery) {
    var wrap = gallery.querySelector('.product__media-gallery-viewer-wrap');
    if (!wrap) return null;
    var bar = wrap.querySelector('.hw-gal-bar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'hw-gal-bar hw-gal-bar--init';
    bar.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('span');
    fill.className = 'hw-gal-bar__fill';
    bar.appendChild(fill);
    wrap.appendChild(bar);
    return bar;
  }

  function start(gallery) {
    var viewer = gallery.querySelector('.product__media-gallery-viewer');
    if (!viewer) return;
    var bar = ensureBar(gallery);
    if (!bar) return;

    markIndicators(gallery, viewer, bar);

    var tries = 0;
    (function waitForSwiper() {
      var swiper = viewer.swiper;
      if (!swiper) {
        if (tries++ > 300) return;
        requestAnimationFrame(waitForSwiper);
        return;
      }

      markIndicators(gallery, viewer, bar);
      update(gallery, bar, swiper);
      requestAnimationFrame(function () {
        bar.classList.remove('hw-gal-bar--init');
      });

      /* ================================================================
         DER RUECKSETZER AM ENDE DER ENDLOSSCHLEIFE, BEHOBEN 31.10.2026
         ================================================================
         Die Leiste wurde vorher bei slideChange, slideChangeTransitionEnd
         UND update neu gesetzt, dazu bei jeder DOM-Aenderung.

         Genau das war der Fehler. Swiper stellt die Endlosschleife her,
         indem es nach dem Uebergang die Slides im DOM UMSORTIERT und
         still auf die Kopie springt (loopFix). Dabei feuern mehrere
         dieser Ereignisse direkt hintereinander, und der Beobachter der
         DOM-Aenderungen feuert zusaetzlich. In diesem Moment steht der
         Index kurz auf einem Zwischenwert. Die Leiste sprang auf diesen
         Zwischenwert und danach zurueck: der kleine Rucks beim Sprung
         vom letzten auf das erste Bild.

         JETZT setzt genau EIN Ereignis die Position: realIndexChange.
         Das feuert einmal je logischem Bildwechsel und genau dann, wenn
         der neue Index feststeht. Waehrend der Umsortierung feuert es
         nicht.

         Der Beobachter der DOM-Aenderungen zaehlt nur noch die Bilder
         nach (Variantenwechsel) und wartet dabei ab, bis die Animation
         wirklich durch ist.

         NICHT WIEDER slideChange ODER update ZUM POSITIONIEREN NUTZEN. */
      swiper.on('realIndexChange', function () {
        update(gallery, bar, swiper);
      });

      var pending = null;
      function recountLater() {
        if (pending) return;
        pending = setTimeout(function () {
          pending = null;
          if (swiper.animating) {
            recountLater();
            return;
          }
          markIndicators(gallery, viewer, bar);
          update(gallery, bar, swiper);
        }, 150);
      }

      var scope = gallery.closest('.product__media-wrapper') || gallery;
      if (window.MutationObserver) {
        new MutationObserver(recountLater).observe(scope, { childList: true, subtree: true });
      }
    })();
  }

  function init() {
    var galleries = document.querySelectorAll('media-gallery.product__media-gallery');
    for (var i = 0; i < galleries.length; i++) start(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
